import { createApiCall } from 'lib/base';

const FETCH_INVESTCORE_NHSV_UPDATE_ACCOUNT_CONTRACT_API_ID =
  'DASHBOARD/FETCH_INVESTCORE_NHSV_UPDATE_ACCOUNT_CONTRACT_API';

const apiCall = createApiCall(
  FETCH_INVESTCORE_NHSV_UPDATE_ACCOUNT_CONTRACT_API_ID,
  ({ id }) => ({
    endpoint: `/api/admin/users/${id}/nhsv/update-account-contract`,
    method: 'POST',
    notify: true,
  })
);

export default apiCall;
